// extracted by mini-css-extract-plugin
module.exports = {"bgHeaderBackground":"Circulars_bgHeaderBackground__rAEBP","pdfDownloadIcon":"Circulars_pdfDownloadIcon__1LU10","lastUpdate":"Circulars_lastUpdate__fm9kV"};